import BookingDetailsView from './booking-details-view';

export default BookingDetailsView;
